import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, CircularProgress, Typography, Button, Box } from "@mui/material";
import { log } from "../../helpers/Logger";
import { CardPayment } from "@mercadopago/sdk-react";
import { initMercadoPago } from "@mercadopago/sdk-react";
initMercadoPago(process.env.REACT_APP_MERCADO_PAGO_PUBLIC_KEY);

export default function CardPaymentComponent(props) {
  const { t } = useTranslation();
  const [ready, setReady] = useState(false);
  const onSubmit = async (formData) => {
    props.onComplete(formData);
  };

  const onError = async (error) => {
    console.log(error);
  };

  const onReady = async (r) => {
    setReady(true);
  };

  return (
    <Grid>
      <Grid item xs>
        <Typography variant="h5">{t("paymentMethod")}</Typography>
      </Grid>
      {!ready && (
        <Grid item xs={12}>
          <CircularProgress />
        </Grid>
      )}
      <Grid item xs={12}>
        <CardPayment
          onSubmit={onSubmit}
          onReady={onReady}
          onError={onError}
          initialization={{ amount: props.total }}
        />
      </Grid>
    </Grid>
  );
}
